import React, {Component} from 'react';
import { Link } from 'react-router';

export default class PressList extends Component {
	constructor(props) {
	  super(props);
	  this.state = {}
	}

  render() {

    const props ={};

    let pressItems = [
      
      {
        date: "Dec 31, 2021",
        source: "Mic1Park Music Media",
        link: "https://www.instagram.com/p/CYKkJFpJJd-/",
        title: "2021 Album of the Year - Spare Parts"
      },
      {
        date: "Dec 26, 2021",
        source: "Local Roots Music North West",
        link: "https://www.localrootsmusicnw.com/?wix-music-track-id=2895338725366724&wix-music-comp-id=comp-kvtx6tx0",
        title: "2021 Top 50 Pt. 1 (Hr 2)"
      },

      {
        date: "Dec 24, 2021",
        source: "Mic1Park Music Media",
        link: "https://open.spotify.com/playlist/3ewATo4hgtVwyHQVgjDF4E?si=2c0c76274c524ae2",
        title: "Top 25 of ‘21 - #7: Hot Wax"
      },
      {
        date: "Oct 26, 2021",
        source: "MIC1PARK MUSIC: ON AIR",
        link: "https://open.spotify.com/episode/36PITiCKdIdk5QfWnL8iVo?si=231a2460701a4139",
        title: "An Interview with Moose Almighty"
      },
      {
        date: "Oct 24, 2021",
        source: "Press Release",
        link: "https://moosealmighty.medium.com/seattle-jam-band-moose-almighty-release-live-album-we-play-shows-6ffa48999fac",
        title: "Seattle Jam Band Moose Almighty Release Live Album “We Play Shows"
      },
      {
        date: "May 5, 2021",
        source: "Dan's Tunes",
        link: "https://danstunesseattle.com/2021/05/05/talking-tracks-spare-parts-by-moose-almighty/",
        title: "Talking Tracks: Spare Parts by Moose Almighty"
      },
      {
        date: "Apr 27, 2021",
        source: "Gregg's Guide to New Music",
        link: "https://open.spotify.com/episode/1XMRdOBeYizzcwToFZx4bv?si=SDtdBmJJS12psh13pvJ7xg",
        title: "Podcast episode #312"
      },
      {
        date: "Apr 09, 2021",
        source: "The Week In Seattle Rock",
        link: "https://open.spotify.com/episode/4LVyP2UOmuVUW9ft1HJHss?si=MnvxBRO4SVC1X_7HHNfPfQ",
        title: "Podcast episode #77"
      },
      {
        date: "Apr 21, 2021",
        source: "CapCity Presents",
        link: "https://open.spotify.com/episode/6faI0uF77L2I42GHhMsIG9?si=OghEfNDTS_S7qncyrg-N_w",
        title: "Podcast episode #25 - Interview with Moose Almighty"
      },
      {
        date: "Mar 26, 2021",
        source: "Jam Band Purist",
        link: "https://www.jambandpurist.com/home/spare-parts-moose-almighty-album-review",
        title: "Moose Almighty: ‘Spare Parts’ Full Album Review by Jam Band Purist"
      },
      {
        date: "Mar 18, 2021",
        source: "New Music Inferno",
        link: "https://www.blogtalkradio.com/newmusicinferno/2021/03/18/new-music-inferno-w-moose-almighty-capital-vices",
        title: "New Music Inferno w/ Moose Almighty & Capital Vices!!!"
      },
      {
        date: "Mar 16, 2021",
        source: "The Sound Podcast with Ira Haberman",
        link: "https://www.thesoundpodcast.com/7-things-march-16-2021/",
        title: "7 Things You Should Be Listening To"
      },
      {
        date: "Mar 12, 2021",
        source: "Hipster Bait",
        link: "https://hipsterbait.com/artists/MooseAlmighty",
        title: "Featured Artist: March 2021"
      },
      {
        date: "Feb 22, 2021",
        source: "Jam Band Purist",
        link: "https://www.jambandpurist.com/home/the-moose-is-loose",
        title: "The Moose Is Loose part deuce: (Moose Almighty Return with a second album)"
      },
      {
        date: "Feb 17, 2021",
        source: "Press Release",
        link: "https://moosealmighty.medium.com/seattle-rock-band-moose-almighty-release-third-album-spare-parts-on-march-26-cd5bdb150263",
        title: "Seattle Rock Band Moose Almighty Release Third Album “Spare Parts” on March 26"
      },
      {
        date: "Nov 16, 2020",
        source: "The Week In Seattle Rock",
        link: "https://open.spotify.com/episode/5CVNGfXDX7uk4GwTF9J2ue?si=lKzsrzRSTciJkQf9zOBpyA",
        title: "Podcast episode #55"
      },
      {
        date: "Aug 13, 2020",
        source: "Klipsun Magazine",
        link: "https://klipsunmagazine.com/we-can-fix-it-in-the-mix-b1bf1d77cb43",
        title: "We Can Fix it in the Mix: A look at the at-home studio spaces musicians are creating, enjoying or just making work for the time being."
      },
      {
        date: "Aug 07, 2020",
        source: "Jam Band Purist",
        link: "https://www.jambandpurist.com/home/moose-almighty-unpacks-the-luggage-underneath-album-review",
        title: "Moose Almighty (Unpacks 'The Luggage Underneath') Album Review"
      },
      {
        date: "Aug 07, 2020",
        source: "The Jamwich",
        link: "http://www.thejamwich.com/2020/08/07/album-review-moose-almighty-the-luggage-underneath/",
        title: "Album Review: Moose Almighty, The Lugagge Underneath"
      },
      {
        date: "Jul 25, 20202",
        source: "Ginger Anne's Jam Bands Podcast",
        link: "https://tunein.com/podcasts/Music-Podcasts/Ginger-Annes-Jam-Bands-p1216462/?topicId=156002726",
        title: "New Releases in August 2020: Moose Almighty, Nick Perri and The Underground Thieves, The Allman Betts Band, Dinner Party, Cory Wong"
      },
      {
        date: "Jul 13, 2020",
        source: "The Jamwich",
        link: "https://www.thejamwich.com/2020/07/13/moose-almighty-set-to-release-sophomore-album-the-luggage-underneath-on-august-7th/",
        title: "Moose Almighty Set To Release Sophomore Album 'The Luggage Underneath' On August 7th"
      },
      {
        date: "Jul 08, 2020",
        source: "Press Release",
        link: "https://moosealmighty.medium.com/moose-almighty-set-to-release-sophomore-album-the-luggage-underneath-on-august-7th-e91d7fc6314c",
        title: "Moose Almighty set to release Sophomore Album ‘The Luggage Underneath’ on August 7th"
      },
      {
        date: "Dec 26, 2019",
        source: "Press Release",
        link: "https://moosealmighty.medium.com/central-saloon-to-host-late-night-mike-gordon-band-after-party-with-moose-almighty-whalien-the-b9284c0678ce",
        title: "Central Saloon to host Late Night Mike Gordon Band After Party with Moose Almighty, Whalien & The Arnolds"
      },
      {
        date: "Nov 17, 2019",
        source: "The Jamwich",
        link: "http://www.thejamwich.com/2019/11/17/seattles-moose-almighty-to-release-new-single-gilded-guilt/",
        title: "Seattle's Moose Almighty To Release New Single 'Gilded Guilt'"
      },
      {
        date: "Apr 12, 2019",
        source: "KAOS Radio",
        link: "https://soundcloud.com/kaosolympia/moose-almighty-studio-session",
        title: "Moose Almighty In Studio Session at KAOS Radio in Olympia, WA"
      },
      {
        date: "Oct 20, 2019",
        source: "Press Release",
        link: "https://medium.com/@moose.almighty.music/seattle-indie-rockers-moose-almighty-release-debut-album-bound-revolving-5c0a713ffc6c",
        title: "Seattle indie rockers Moose Almighty release debut album “Bound & Revolving”"
      }
    ]

    let list = pressItems.map(press => {
      return (
        <div className="PressList__Item">
          <div className="PressList__Item__Date">{press.date} — </div>
          <div className="PressList__Item__Source">{press.source}: </div>
          <a target="_blank" href={press.link}>
            <div className="PressList__Item__Title">{press.title}</div>
          </a>
          
        </div>
      )
    });
    
    return (
      <div>
        {list}
      </div>
    )
  }
}

// {
//         date: "",
//         source: "",
//         link: "",
//         title: ""
//       }




// WEBPACK FOOTER //
// ./src/components/Sections/PressList/PressList.js